/***
*
*   HOME LAYOUT
*   Main website layout
*
**********/

import React, { Fragment } from 'react';
import { HomeNav, Footer, useLocation } from 'components/lib';

export function HomeLayout(props){

  const location = useLocation();

  const noChrome = ['/', '/forgotpassword', '/resetpassword'];
  if (noChrome.includes(location?.pathname)) {
    return <props.children {...props.data} />;
  }

  return (
    <Fragment>
      <main className='home'>

        <HomeNav />
        { <props.children {...props.data }/> }

      </main>
      <Footer />
    </Fragment>
  );
}
